import api from '@/utils/http'

/**
 功能：获取树状路由列表
 time: 2025-13-01 17:13:44
 **/
export function getAuthList() {
    return api.get('/admin/auth/getList')
}

/**
 功能：获取select一级数据
 time: 2025-54-02 09:54:36
 **/
export function getParentAuthList() {
    return api.get('/admin/auth/getParentList')
}

/**
 功能：保存路由
 time: 2025-55-02 09:55:40
 **/
export function saveAuth(data) {
    return api.post('/admin/auth/eSave', data)
}

/**
 功能：获取路由详情
 time: 2025-54-02 10:54:10
 **/
export function getAuthDetail(id) {
    return api.post('/admin/auth/getDetail', {id: id})
}

/**
 功能：删除路由
 time: 2025-14-02 14:14:27
 **/
export function deleteAuth(id) {
    return api.post('/admin/auth/del', {id: id})
}

/**
 功能：获取路由列表
 time: 2025-23-02 14:23:56
 **/
export function getRouterList() {
    return api.get('/admin/auth/getRouterList')
}

/**
 功能：查询路由集合 用作添加角色
 time: 2025-28-02 16:28:57
 **/
export function getAllRouterList() {
    return api.get('/admin/auth/getAllRouterList')
}
